import Base from '@studiometa/js-toolkit';

/**
 * Header class.
 */
export default class Header extends Base {
  /**
   * Class cofnig
   * @return {Object}
   */
  static config = {
    name: 'Header',
    refs: ['menu', 'btnOpen', 'navLanguages', 'links[]'],
  };

  isOpen = false;

  /**
   * Handle the open/close logic for the menu
   * The open ref is the hamburger icon
   * @return {void}
   */
  onBtnOpenClick() {
    if (this.isOpen) {
      return this.closeMenu();
    }

    return this.openMenu();
  }

  /**
   * On click on a link, close the menu
   */
  onLinksClick() {
    this.closeMenu();
  }

  /**
   * Open Menu
   * @return {void}
   */
  openMenu() {
    this.$refs.menu.classList.add('menu--open');
    this.$refs.navLanguages.classList.remove('z-goku');
    document.body.classList.add('overflow-hidden');
    this.$el.classList.add('menu-is-open');

    this.isOpen = true;
  }

  /**
   * Close Menu
   * @return {void}
   */
  closeMenu() {
    this.$refs.menu.classList.remove('menu--open');
    this.$refs.navLanguages.classList.add('z-goku');
    document.body.classList.remove('overflow-hidden');
    this.$el.classList.remove('menu-is-open');

    this.isOpen = false;
  }

  /**
   * Display/hide header when scrolling up/down
   * @param  {Object} e Scroll object
   */
  scrolled(e) {
    if (window.scrollY > 50) {
      if (e.delta.y > 0 && !this.$el.classList.contains('header--up')) {
        this.isDisplaying = false;
        this.$el.classList.add('header--up');
      }
      if (e.delta.y < 0) {
        this.isDisplaying = true;
        this.$el.classList.add('header--sticky');
        this.$el.classList.remove('header--up');
      }
    }

    if (window.scrollY <= 50) {
      this.$el.classList.remove('header--sticky');
    }
  }
}
